<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="لماذا-أرتدي-الاسود">
<h1><span dir="rtl">لماذا أرتدي الاسود؟</span></h1>
<div class="section level2" id="why-im-wearing-black">
<h2>? Why <strong>I’m</strong> wearing black </h2>
<p><span dir="rtl">أنا لا أرتدي الأسود لأني أقيم عزاء، أو لأني بأيام حدادي.</span></p>
<p><span dir="rtl">بل لأني أريد أن أتقبّل ما تقدمة الحياة لي بتفاؤل وصدرٍ رحبٍ، الأسود يمتص كُل ما هو ليس جميل ويعيد حياكته لي بشيءٍ أجمل.</span></p>
<p><span dir="rtl">يُمد لي السعادة كما يُمد الأكسجين الحياة، يبعث بي الأمل كما تفعل الشمس عند شروقها.</span></p>
<p><span dir="rtl">لذا.. لا شيء مُحزن يرتبط به أبداً، حتى في وقت العزاء، هو فقط يخفف الحُزن الذي يتلقاه الجميع عند فقد عزيز.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?af35d400